import { ApiConstants } from '../../constants/actions';
import createReducer from '../../helpers/CreateReducer';

interface DownloadInvoiceState {
  isLoading: string[];
  noPersistance: boolean;
}

export const getInitialState = (): DownloadInvoiceState => ({
  isLoading: [],
  noPersistance: true
});

const AddId = (state: DownloadInvoiceState, id: string): string[] => [
  ...state.isLoading,
  id
];

const RemoveId = (state: DownloadInvoiceState, id: string): string[] => [
  ...(state.isLoading || []).filter(value => value !== id)
];

interface ActionPayload {
  id: string | number;
  idType: string;
}

export default createReducer(getInitialState, {
  [`${ApiConstants.DOWNLOAD_INVOICE}_REQUEST`]: (
    state: DownloadInvoiceState,
    { id, idType }: ActionPayload
  ) => ({
    ...state,
    isLoading: AddId(state, `${idType}-${id}`)
  }),

  [`${ApiConstants.DOWNLOAD_INVOICE}_SUCCESS`]: (
    state: DownloadInvoiceState,
    { id, idType }: ActionPayload
  ) => ({
    ...state,
    isLoading: RemoveId(state, `${idType}-${id}`)
  }),

  [`${ApiConstants.DOWNLOAD_INVOICE}_FAILURE`]: (
    state: DownloadInvoiceState,
    { id, idType }: ActionPayload
  ) => ({
    ...state,
    isLoading: RemoveId(state, `${idType}-${id}`)
  })
});
